import React, { useEffect, useState } from "react";
import clsx from 'clsx'
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IRegras } from "../../interfaces/IRegras";
import { IDocumentos } from "../../interfaces/IDocumentos";
import Documentos from "./Documentos";
import Regras from "./Regras";
import DocumentosService from "../../services/DocumentosService";
import RegrasService from "../../services/RegrasService";

export type BotaoAdicional = {
  texto: string;
  acao: () => void;
}

function DocumentosRegras() {

  const { classes } = useLayout();
  const [titulo, setTitulo] = useState<string>('');
  const [abaSelecionada, setAbaSelecionada] = useState<number>(1);
  const [botaoAdicional, setBotaoAdicional] = useState<BotaoAdicional>();
  const [regras, setRegras] = useState<IRegras[]>();
  const [documentos, setDocumentos] = useState<IDocumentos[]>();
  const [carregado, setCarregado] = useState<boolean>(false);
  const opcoesBotoesCabecalho = [
    { id: 1, descricao: 'Regras', habilitado: true },
    { id: 2, descricao: 'Documentos', habilitado: true }
  ];
  
  useEffect(() => {

    setTimeout(async () => {
      await carregarInformacoes();
    }, 1000)

    //eslint-disable-next-line
  }, [])
  
  async function carregarInformacoes() {
    setCarregado(false);
    await RegrasService.obterTodos(x => setRegras(x));
    await DocumentosService.obterTodos(x => setDocumentos(x));
    setCarregado(true);
  }

  function trocarAbaSelecionada(id: number) {
    switch(id) {
      case 1:
        return <Regras carregando={carregado} titulo={setTitulo} botaoAdicional={setBotaoAdicional} regras={regras} setRegras={setRegras} documentos={documentos} />
        case 2:
        return <Documentos carregando={carregado} titulo={setTitulo} botaoAdicional={setBotaoAdicional} documentos={documentos} setDocumentos={setDocumentos} />
    }
  }

  function BotoesCabecalho() {
    return <>
      {
        opcoesBotoesCabecalho.map((x, index) => <button key={index} id={`item-${x.id}`} className={`btn btn-filtro ${x.id === abaSelecionada && x.habilitado && 'ativo'}`} disabled={!x.habilitado} onClick={() => x.habilitado && setAbaSelecionada(x.id)}>{x.descricao}</button>)
      }
    </>
  };

  return <>
    <PageTitle breadcrumbs={[]}>{ titulo }</PageTitle>
    <div className='toolbar' id='kt_toolbar'>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
        <DefaultTitle />
        <div className='d-flex align-items-center py-1' style={{ visibility: botaoAdicional?.acao && botaoAdicional?.texto ? 'visible' : 'hidden' }}>
            <button onClick={botaoAdicional?.acao} className='btn btn-sm btn-primario'>
              <i className="icon-lg text-white fas fa-plus"/>
              <span style={{ verticalAlign: 'middle' }}> { botaoAdicional?.texto } </span>
            </button>
        </div>
      </div>
    </div>

    <BotoesCabecalho />
    { 
      trocarAbaSelecionada(abaSelecionada)
    }
  </>
};

export default DocumentosRegras;